import get from "lodash/get";
import { ComponentConfig } from "../Widget/Widget";

export const createCornerBoxes = (component: HTMLElement) => {
  const elementBounds = component.getBoundingClientRect();

  const topLeftBox = document.createElement("div");
  topLeftBox.id = "component-base-top-left-box";
  topLeftBox.classList.add("component-base-corner-box");
  topLeftBox.style.top = elementBounds.top - 5 + "px";
  topLeftBox.style.left = elementBounds.left - 5 + "px";

  const topRightBox = document.createElement("div");
  topRightBox.id = "component-base-top-right-box";
  topRightBox.classList.add("component-base-corner-box");
  topRightBox.style.top = elementBounds.top - 5 + "px";
  topRightBox.style.left = elementBounds.right - 5 + "px";

  const bottomRightBox = document.createElement("div");
  bottomRightBox.id = "component-base-bottom-right-box";
  bottomRightBox.classList.add("component-base-corner-box");
  bottomRightBox.style.top = elementBounds.bottom - 5 + "px";
  bottomRightBox.style.left = elementBounds.right - 5 + "px";

  const bottomLeftBox = document.createElement("div");
  bottomLeftBox.id = "component-base-bottom-left-box";
  bottomLeftBox.classList.add("component-base-corner-box");
  bottomLeftBox.style.top = elementBounds.bottom - 5 + "px";
  bottomLeftBox.style.left = elementBounds.left - 5 + "px";

  document.body.appendChild(topLeftBox);
  document.body.appendChild(topRightBox);
  document.body.appendChild(bottomRightBox);
  document.body.appendChild(bottomLeftBox);
};

export const updateCornerBoxes = (component: HTMLElement) => {
  const elementBounds = component.getBoundingClientRect();

  const topLeftBox = document.getElementById("component-base-top-left-box");
  const topRightBox = document.getElementById("component-base-top-right-box");
  const bottomRightBox = document.getElementById(
    "component-base-bottom-right-box"
  );
  const bottomLeftBox = document.getElementById(
    "component-base-bottom-left-box"
  );

  if (topLeftBox) {
    topLeftBox.style.top = elementBounds.top - 5 + "px";
    topLeftBox.style.left = elementBounds.left - 5 + "px";
  }

  if (topRightBox) {
    topRightBox.style.top = elementBounds.top - 5 + "px";
    topRightBox.style.left = elementBounds.right - 5 + "px";
  }

  if (bottomRightBox) {
    bottomRightBox.style.top = elementBounds.bottom - 5 + "px";
    bottomRightBox.style.left = elementBounds.right - 5 + "px";
  }

  if (bottomLeftBox) {
    bottomLeftBox.style.top = elementBounds.bottom - 5 + "px";
    bottomLeftBox.style.left = elementBounds.left - 5 + "px";
  }
};

export const removeCornerBoxes = () => {
  const topLeftBox = document.getElementById("component-base-top-left-box");
  const topRightBox = document.getElementById("component-base-top-right-box");
  const bottomRightBox = document.getElementById(
    "component-base-bottom-right-box"
  );
  const bottomLeftBox = document.getElementById(
    "component-base-bottom-left-box"
  );

  if (topLeftBox && document.body.contains(topLeftBox)) {
    document.body.removeChild(topLeftBox);
  }

  if (topRightBox && document.body.contains(topRightBox)) {
    document.body.removeChild(topRightBox);
  }

  if (bottomRightBox && document.body.contains(bottomRightBox)) {
    document.body.removeChild(bottomRightBox);
  }

  if (bottomLeftBox && document.body.contains(bottomLeftBox)) {
    document.body.removeChild(bottomLeftBox);
  }
};

export const checkForBoundariesUpdate = (
  prevConfig: ComponentConfig,
  config: ComponentConfig,
  component: HTMLElement
) => {
  const isWidthDifferent =
    get(prevConfig, "style.width") !== get(config, "style.width");
  const isHeightDifferent =
    get(prevConfig, "style.height") !== get(config, "style.height");
  const isTopDifferent =
    get(prevConfig, "style.top") !== get(config, "style.top");
  const isLeftDifferent =
    get(prevConfig, "style.left") !== get(config, "style.left");

  if (
    isWidthDifferent ||
    isHeightDifferent ||
    isTopDifferent ||
    isLeftDifferent
  ) {
    updateCornerBoxes(component);
  }
};
